import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Icon } from '@panel/commons';
import { setHotjarIdentify } from '@panel/commons/helpers/hotjarHelper';
import { useThemeBreakpoint } from '@panel/leads/src/components/hooks/useResize';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { userInfoSelectors } from '../../state/ducks/user';
import HeaderDesktop from './headerDesktop/HeaderDesktop';
import HeaderMobile from './headerMobile/HeaderMobile';
import { ActivityOperations } from '../../state/ducks/userActivity';
import ExtendTheme from '../configuration/ExtendTheme';
import { ModalProvider } from '../../components/modal';
import { useLogin } from '../../hooks/useLogin';
import { bumexFeaturesKeys } from '../../constants/bumexFeatures';
import { bumexFeatureSelectors } from '../../state/ducks/bumexFeatures';

const ContactPhone = styled.div`
  height: 30px;
  background: #eaeaea;
  color: #707070;
  padding-right: 30px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  @media ${({ theme }) => theme.v2.breakpoints.MinAndMax.tablet} {
    top: 0;
    position: fixed;
    z-index: 4;
  }
  @media ${({ theme }) => theme.v2.breakpoints.MinAndMax.mobile} {
    top: 0;
    position: fixed;
    z-index: 9999;
  }
`;

function HeaderContainer() {
  const userInfo = useSelector(userInfoSelectors.getuserInfoState);
  const { t } = useTranslation();
  const siteId = process.env.REACT_APP_BUILD_SITE;
  const brasilSitesId = ['ICBR', 'IWBR', 'WIBR'];
  const isBrasil = brasilSitesId.indexOf(siteId) !== -1;
  const [reachedBreakpoint] = useThemeBreakpoint();
  const dispatch = useDispatch();
  const { bumexFeatures } = useSelector(bumexFeatureSelectors.getBumexFeatureState);

  const isPortalWithNewReputation = bumexFeatures.get(bumexFeaturesKeys.NEW_REPUTATION_SECTION);

  useEffect(() => {
    if (window.hj && userInfo.userTypeId) {
      setHotjarIdentify(window.hj, userInfo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo.userTypeId, userInfo.userFromApp]);

  useEffect(() => {
    dispatch(ActivityOperations.getUnReadMessageCounter());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPortalWithNewReputation]);

  const { LoginForm, login } = useLogin();

  return (
    <>
      {!userInfo.userFromApp && (
        <ExtendTheme>
          <ModalProvider>
            {isBrasil && (
              <ContactPhone>
                <Icon name='headPhone' colorFill='#333' width={30} height={30} viewBox='7 0 30 15' />
                {t('panel.header.contactPhone')}
              </ContactPhone>
            )}
            {reachedBreakpoint === 'desktop' ? (
              <HeaderDesktop isBrasil={isBrasil} />
            ) : (
              <HeaderMobile isBrasil={isBrasil} />
            )}
            {login && <LoginForm />}
          </ModalProvider>
        </ExtendTheme>
      )}
    </>
  );
}

export { HeaderContainer };
